import type { Locale } from "../api/types";
import { chromeLocale } from "../lib/locale-context";

/** AI attribution badge (contract 0.10.62): "Name · AI" wherever an actor is shown. Thai provisional, unreachable while chrome is English-only. */
export type AiTextKey = "badge" | "badgeLabel" | "notice";

export const AI_TEXT: Record<Locale, Record<AiTextKey, string>> = {
  en: {
    badge: "AI",
    badgeLabel: "done through an AI assistant",
    notice: "Done through an AI assistant",
  },
  th: {
    badge: "AI",
    badgeLabel: "ดำเนินการผ่านผู้ช่วย AI",
    notice: "ดำเนินการผ่านผู้ช่วย AI",
  },
};

export function aiText(key: AiTextKey, locale: Locale | undefined): string {
  return AI_TEXT[chromeLocale(locale)][key];
}
